import { DropdownItem } from 'reactstrap';
import { useHandleFlagJob } from '../dispatchPlus/Dispatch/Jobs/Job/FlagJob';

export const FlagJob = ({
    job, day, onSuccess,
}) => {
    const handleClick = useHandleFlagJob({
        job, day, onSuccess,
    });

    return (
        <DropdownItem
            className="text-danger"
            onClick={handleClick}
        >
            Flag Job
        </DropdownItem>
    );
};